import { Fragment, ReactElement } from 'react'
import styled from 'styled-components'

import { SectionDiv, SummaryDiv } from '../TextStyle'
import { usingTerms, usingTermsLinks } from './UsingIterms'
import { LinkText } from '@/components/elements/LinkText'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Index } from '@/components/enlayouts/Legal/Index'
import { SectionTitle } from '@/components/enlayouts/Legal/SectionTitle'

const sectionTitle = {
  children: <h2>Terms of Use</h2>,
}

const tSummary = (
  <>
    <p>
      Regarding this website (hereinafter referred to as the “Website”) which is operated by TRIAL Group (representing TRIAL Holdings, Inc., and its group companies*.), the users of the Website (hereinafter referred to as the &quot;Users&quot;) are deemed to have agreed to the Terms of Use (hereinafter referred to as the &quot;Terms&quot;) by using it. 
      <br />
      Besides, the Terms may be changed. Users are requested to check the latest content of the Terms.
    </p>
    <p>
      ※
      <LinkText path="/en/company/overview/" text="Here " />
      are the group companies of TRIAL Holdings, Inc.

    </p>
  </>
)

export const UsingTermsPage = () => {
  return (
    <>
      <Head
        title="Terms of Use"
        description="The terms of Use for TRIAL Holding, Inc."
        ogp={{ type: 'article', url: 'en/legal/terms/' }}
      />
      <UsingContainer>
        <SectionTitle {...sectionTitle} />
        <Spacer h={{ pc: 70, sp: 60 }} />
        <SummaryDiv>{tSummary}</SummaryDiv>
        <Spacer h={{ pc: 70, sp: 35 }} />
        <Index columnGap={84} listType="article" links={usingTermsLinks} />
        <Spacer h={{ pc: 70, sp: 40 }} />
        {usingTerms.map(({ children, id }, index) => (
          <Fragment key={`${id}${index}`}>
            <SectionDiv id={id}>{children}</SectionDiv>
            {index < usingTerms.length - 1 && <Spacer h={{ pc: 70, sp: 39 }} />}
          </Fragment>
        ))}
      </UsingContainer>
    </>
  )
}
UsingTermsPage.getLayout = (page: ReactElement) => {
  const pageTitle = {
    title: 'Legal',
    subTitle: '',
  }

  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Legal', path: '/en/legal/' },
    { name: 'Terms of Use', path: '' },
  ]

  return (
    <TitleLayout
      {...pageTitle}
      breadCrumbs={breadCrumbs}
      isRequiredBackground={false}
    >
      {page}
    </TitleLayout>
  )
}

const UsingContainer = styled.div`
  width: 1040px;
  padding-top: 62px;
  padding-bottom: 130px;
  margin: 0 auto;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 40px 20px 70px;
  }
`
